function alphaSort(a, b) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

function groupTags({ tagGroups, tags }) {
  const groups = {};
  tagGroups.forEach((group) => {
    groups[group._id] = {
      ...group,
      tags: [],
    };
  });

  tags.forEach((tag) => {
    groups[tag.group] = {
      ...groups[tag.group],
      tags: [...groups[tag.group].tags, tag],
    };
  });

  // Convert to alphabetically sorted array
  const temp = Object.values(groups).sort((a, b) => (
    alphaSort(a.name.toLowerCase(), b.name.toLowerCase())
  )).map(group => ({
    ...group,
    tags: group.tags.sort((a, b) => (
      alphaSort(a.display.toLowerCase(), b.display.toLowerCase())
    )),
  }));
  return temp;
}

export default function tagGroupsReducer(state, action) {
  const tagGroups = action.tagGroups || state.tagGroups;
  if (action.type === 'ADD_GROUP') tagGroups.push(action.group);
  switch (action.type) {
    case 'INITIAL_SETUP':
    case 'ADD_TAG':
    case 'UPDATE_TAG':
    case 'ADD_GROUP':
    case 'UPDATE_GROUP':
      return {
        ...state,
        tagGroups: groupTags({
          tagGroups: tagGroups.map((group) => {
            if (action.group && group._id === action.group._id) {
              return {
                ...group,
                ...action.group,
              };
            } return group;
          }),
          tags: action.tags ? action.tags : state.tags,
        }),
      };
    case 'DELETE_GROUP':
      return {
        ...state,
        tagGroups: state.tagGroups.filter(group => group._id !== action.groupId),
      };
    case 'DELETE_TAG':
      return {
        ...state,
        tagGroups: state.tagGroups.map(group => ({
          ...group,
          tags: group.tags.filter(tag => (tag._id !== action.tagId)),
        })),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tagGroups.js